module.exports = (__webpack_require__(0))(67);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/collections/ItemCollection.js from dll-reference girder_lib
// module id = 135
// module chunks = 0